<ifbp-dashboard-page-shell [page]="page$ | async" [asOfUtc]="(vm$ | async)?.asOfUtc ?? null">
  <ng-container *ngIf="vm$ | async as vm" [ngSwitch]="vm.state">
    <ifbp-pipeline-health-skeleton *ngSwitchCase="VmState.LOADING"></ifbp-pipeline-health-skeleton>
    <ifbp-snapshot-error-card *ngSwitchCase="VmState.ERROR" [message]="vm.errorMessage"></ifbp-snapshot-error-card>
    <div class="pipeline" *ngSwitchCase="VmState.DATA">
      <section class="pipeline__cards">
        <ifbp-pipeline-metric-card
          class="pipeline__card"
          *ngFor="let card of vm.data?.cards; trackBy: trackByCard"
          [vm]="card"
        ></ifbp-pipeline-metric-card>
      </section>
      <ifbp-pipeline-funnel-card
        [bars]="vm.data?.bars"
        [legendLabel]="vm.data?.legendLabel"
      ></ifbp-pipeline-funnel-card>
    </div>
  </ng-container>
</ifbp-dashboard-page-shell>
